import tryCreateOwaDate from './tryCreateOwaDate';
import handleOwaDateError from './handleOwaDateError';
import Entity from 'txp-data/lib/schema/Entity';

export default function tryCreateTxpOwaDate(dateTime: string, entity: Entity): boolean {
    return tryCreateOwaDate(dateTime, (e: Error) => {
        handleOwaDateError(e, entity);
    });
}
